/**
 * Created by Jan Bradac on 5.8.2016.
 */

(function (Lfl, $, undefined) {
    (function (Events, $, undefined) {
        if(Lfl.Files.isLoadedAlready(Lfl.Events, 'EventDataModifier')) {
            return;
        }
    
        /*
         |==============================================================================================================
         | Documentation
         |==============================================================================================================
         */ 
                  
        /**
         * An object that helps with adding data to the jQuery event class
         *  
         * @memberOf Lfl.Events
         */
        Lfl.Events.EventDataModifier;
        
        (function (EventDataModifier, $, undefined) {     
            /*
            |===========================================================================================================
            | Object definition 
            |===========================================================================================================
            */
            var PREFIX = 'lflData';

            /**
             * The name of member variable which will be set on the event in case it was consumed already.
             * @type {string}
             */
            var WAS_CLICK_CONSUMED_MEMBER =  PREFIX + "." + "wasMouseupConsumedAlready";

            /*
            |-----------------------------------------------------------------------------------------------------------
            | Public methods
            |-----------------------------------------------------------------------------------------------------------
            */
              
            /**
             * Adds data to the event notifying that the click action was consumed already and underlying components
             * should not react to it.
             * However, it is entirely up to the underlying components' handlers how they handle this information.
             *
             *
             * @memberOf Lfl.Events.EventDataModifier
             * @param event
             */
            EventDataModifier.setMouseupWasConsumed = function (event) {
                event.originalEvent[WAS_CLICK_CONSUMED_MEMBER] = true;

                if(event.type !== 'mouseup') {
                    console.warn("Registering that mouseup was consumed on event that is not a mouseup!");
                }
            };

            /**
             * Checks whether the event's click action was already marked as consumed.
             *
             * @memberOf Lfl.Events.EventDataModifier
             * @param event
             * @return boolean
             */
            EventDataModifier.wasMouseupConsumedAlready = function (event) {
                if(event.type !== 'mouseup') {
                    console.warn("Asking if mouseup was consumed on event that is not a mouseup!");
                }

                if (typeof event.originalEvent[WAS_CLICK_CONSUMED_MEMBER] === 'undefined') {
                    // No component has yet defined that the click was consumed
                    return false;
                }

                return event.originalEvent[WAS_CLICK_CONSUMED_MEMBER];
            };
            
            /*
            |-----------------------------------------------------------------------------------------------------------
            | Private methods
            |-----------------------------------------------------------------------------------------------------------
            */
        }(Events.EventDataModifier = Events.EventDataModifier || {}, jQuery));       
    }(Lfl.Events = Lfl.Events || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));